import { useCallback, useState } from "react";
import { TEntityInfo } from "../types/utility";

export const usePopover = () => {
  const [anchorPopoverEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [openPopover, setOpenPopover] = useState(false);
  const [info, setInfo] = useState<TEntityInfo | null>(null);

  const handleOpenPopover = (
    event: React.MouseEvent<HTMLButtonElement>,
    info?: TEntityInfo,
  ) => {
    setAnchorEl(event.currentTarget);
    setOpenPopover(true);
    if (info) {
      setInfo(info);
    }
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
    setOpenPopover(false);
  };

  const handleCloseCustomPopover = useCallback(
    (event: KeyboardEvent | MouseEvent) => {
      handleClosePopover();
    },
    [],
  );

  return {
    anchorPopoverEl,
    openPopover,
    info,
    handleOpenPopover,
    handleClosePopover,
    handleCloseCustomPopover,
  };
};
